import api from './api';

export const getCharacters = (params, config = {}) => api.get('/api/characters', { params, ...config });
export const getCharacter = (key, stage) =>
  api.get(`/api/characters/${key}`, { params: stage != null ? { stage } : undefined });
export const getCharacterDialogues = (key, params) => api.get(`/api/characters/${key}/dialogues`, { params });
export const getCharacterMissions = (key) => api.get(`/api/characters/${key}/missions`);

// Relationship progression (authenticated player)
export const getMyCharacters = () => api.get('/api/characters/mine');
export const meetCharacter = (key) => api.post(`/api/characters/${key}/meet`);
export const interactCharacter = (key, reason = 'talk') => api.post(`/api/characters/${key}/interact`, { reason });
